import { render, staticRenderFns } from "./aboutStyle.vue?vue&type=template&id=750c0f33&scoped=true&"
import script from "./aboutStyle.vue?vue&type=script&lang=js&"
export * from "./aboutStyle.vue?vue&type=script&lang=js&"
import style0 from "./aboutStyle.vue?vue&type=style&index=0&id=750c0f33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750c0f33",
  null
  
)

export default component.exports